import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { ColorTarget } from '@mode-vegas/vegas';
import { IconButtonComponent, IconComponent } from '@mode/capra';
import { OrgTypes } from '@mode/shared/contract-common';
import { ColorPickerContainerComponent, ColorSwatchSelectorComponent } from '@mode/colors/ui';
import { BackgroundSettingsToggleComponent } from '../background-settings-toggle/background-settings-toggle.component';

export interface ColorFlyoutData {
  selectedColorPalette: OrgTypes.ColorPalette | undefined;
  allColorPalettes: readonly OrgTypes.ColorPalette[];
  updateOnMove: boolean;
  activeColor: string;
  showTextSettings: boolean;
  enableTextSettings: boolean;
  isUseAsBackground: boolean;
  colorSelected: (colorSelected: string, selectedPalette: OrgTypes.ColorPalette, isCustom: boolean) => void;
  markTargetSelected: (target: ColorTarget) => void;
}

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatLegacyMenuModule,
    ColorSwatchSelectorComponent,
    IconComponent,
    IconButtonComponent,
    BackgroundSettingsToggleComponent,
    ColorPickerContainerComponent,
  ],
  selector: 'mode-color-flyout-menu',
  templateUrl: './color-flyout-menu.component.html',
  styleUrls: ['./color-flyout-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorFlyoutMenuComponent {
  selectedColorPalette: OrgTypes.ColorPalette | undefined;
  allColorPalettes: readonly OrgTypes.ColorPalette[];
  updateOnMove: boolean;
  activeColor: string;
  showTextSettings: boolean;
  enableTextSettings: boolean;
  isUseAsBackground: boolean;
  colorSelected: (colorSelected: string, selectedPalette: OrgTypes.ColorPalette, isCustom: boolean) => void;
  markTargetSelected: (target: ColorTarget) => void;

  currentPalette: OrgTypes.ColorPalette | undefined = undefined;
  isShowCustom = true;
  savedColor = '';

  constructor(@Inject(MAT_LEGACY_DIALOG_DATA) private data: ColorFlyoutData) {
    this.selectedColorPalette = data.selectedColorPalette;
    this.allColorPalettes = data.allColorPalettes;
    this.updateOnMove = data.updateOnMove;
    this.activeColor = data.activeColor;
    this.showTextSettings = data.showTextSettings;
    this.enableTextSettings = data.enableTextSettings;
    this.isUseAsBackground = data.isUseAsBackground;
    this.colorSelected = data.colorSelected;
    this.markTargetSelected = data.markTargetSelected;

    this.currentPalette = this.selectedColorPalette;
    this.savedColor = this.activeColor;
  }

  onPaletteChanged(palette: OrgTypes.ColorPalette) {
    this.currentPalette = palette;
  }

  onColorSelected(color: string, selectedPalette?: OrgTypes.ColorPalette) {
    this.activeColor = color;

    if (selectedPalette) {
      this.currentPalette = selectedPalette;
      this.colorSelected(color, this.currentPalette, this.isShowCustom);
    } else if (this.selectedColorPalette) {
      this.colorSelected(color, this.selectedColorPalette, this.isShowCustom);
    }
  }

  onMarkTargetClick(target: ColorTarget) {
    this.isUseAsBackground = target === 'background';
    this.markTargetSelected(target);
  }

  onTabClick(isCustom = true) {
    this.isShowCustom = isCustom;
  }
}
